import ChevronLeftSVG from "@design-system/ui-icons/vanilla/ChevronLeft"
import { createIcon } from "../createIcon"

export const ChevronLeftIcon = createIcon(ChevronLeftSVG)
